<template>
  <span>
    <input type="checkbox" class="fct-checkbox" :id="row._id"
           v-model='row._checked' :checked='row._checked'>
    <label :for="row._id"></label>
  </span>
</template>

<script>
import gridCell from '../../../mixins/gridCell.js'

export default {
  mixins: [gridCell],
}
</script>

<style scoped lang="scss">
</style>
